function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var purchaseService = require('./service.js');
var calculatePriceTaxFeeAdjusters = require('./calculate.js');
var overridePrices = require('./override.js');
var usePromoService = require('./promotions.js');
var discountontotalService = require('../../module/PTFs/discountontotal.js');
var feebusterService = require('../../module/PTFs/feebuster.js');
var feeService = require('../../module/PTFs/fee.js');
var freeproductsService = require('../../module/PTFs/freeproducts.js');
var manualdiscountService = require('../../module/PTFs/manualdiscount.js');
var modifierService = require('../../module/PTFs/modifier.js');
var priceoverrideService = require('../../module/PTFs/priceoverride.js');
var taxService = require('../../module/PTFs/tax.js');
var taxfreesaleService = require('../../module/PTFs/taxfreesale.js');
function _addModifiersPriceTaxFeeAdjusters(purchase) {
  var modifierGroups = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  if (!modifierGroups || !purchase.modifiers) {
    return;
  }
  var selectedModifiers = _generateModifierInfo(purchase.modifiers, purchase.item_groups_list, modifierGroups);
  Object.keys(selectedModifiers).forEach(function (group) {
    selectedModifiers[group].forEach(function (modifier) {
      purchaseService.priceTaxFeeAdjusters.push(new modifierService.priceTaxFeeAdjuster(modifier, purchase.uuid, group));
    });
  });
}
function _generateModifierInfo(modifierList, itemGroupList, modifierGroups) {
  var result = {};
  modifierList.forEach(function (m) {
    var group = (modifierGroups.find(function (g) {
      return g.modifiers.find(function (md) {
        return md.upc == m.upc;
      }) && itemGroupList.includes(g.modifier_group);
    }) || {}).modifier_group;
    if (group) {
      var clone_modifier = _objectSpread(_objectSpread({}, m), {}, {
        qty: m.pricing.qty,
        cents: m.pricing.cents / +m.pricing.qty
      });
      (result[group] || (result[group] = [])).push(clone_modifier);
    }
  });
  return result;
}
function _transformProduct(product, i) {
  var _product$redemption_c, _product$pricing, _product$redemption_c2, _product$pricing2, _product$redemption_c3, _product$redemption_p, _product$redemption_p2, _product$pricing3, _product$pricing4, _product$pricing5;
  var calculatedQty = product.byweight ? product.qty * 100 : product.qty;
  var pricing = {
    qty: 1,
    cents: product.cents || 0,
    incltaxes: !!product.includes_taxes,
    inclfees: !!product.includes_fees,
    fee_multiplier: product.fee_multiplier || 1,
    byweight: !!product.byweight
  };
  return {
    byweight: !!product.byweight,
    clubId: ((_product$redemption_c = product.redemption_club) === null || _product$redemption_c === void 0 ? void 0 : _product$redemption_c.id) || product.club_id || null,
    dept: product.dept,
    disc: 0,
    feeinc: ((_product$pricing = product.pricing) === null || _product$pricing === void 0 ? void 0 : _product$pricing.inclfees) || pricing.inclfees,
    final_weight: null,
    isebt: (product.isebt === null ? product.deptisebt : product.isebt) || false,
    ismodifier: !!product.is_modifier,
    isRedemption: ((_product$redemption_c2 = product.redemption_club) === null || _product$redemption_c2 === void 0 ? void 0 : _product$redemption_c2.id) || product.is_redemption || null,
    item_groups_list: product.modifier_groups,
    labeledprice: false,
    modifiers: product.modifiers,
    moreinfo: {},
    note: product.note || '',
    orderSequence: i.toString().padStart(4, '0'),
    picpak: product.extension ? product.extension.picpak : [],
    plu: null,
    price: ((_product$pricing2 = product.pricing) === null || _product$pricing2 === void 0 ? void 0 : _product$pricing2.cents) || pricing.cents,
    pricing: product.pricing || pricing,
    qty: calculatedQty,
    redemptionClub: (_product$redemption_c3 = product.redemption_club) !== null && _product$redemption_c3 !== void 0 ? _product$redemption_c3 : null,
    redemptionPoints: (_product$redemption_p = product.redemption_points) !== null && _product$redemption_p !== void 0 ? _product$redemption_p : null,
    redemptionPointsOfferId: ((_product$redemption_p2 = product.redemption_points) === null || _product$redemption_p2 === void 0 ? void 0 : _product$redemption_p2.id) || product.redemption_points_offer_id || null,
    refund: !!product.refund,
    revauths: (product.pricebook_info || {}).revauths || product.revauths,
    showtext: product.name,
    skuprice: ((_product$pricing3 = product.pricing) === null || _product$pricing3 === void 0 ? void 0 : _product$pricing3.cents) || pricing.cents,
    skuqty: ((_product$pricing4 = product.pricing) === null || _product$pricing4 === void 0 ? void 0 : _product$pricing4.qty) || pricing.qty,
    taxinc: ((_product$pricing5 = product.pricing) === null || _product$pricing5 === void 0 ? void 0 : _product$pricing5.incltaxes) || pricing.incltaxes,
    upc: product.upc,
    uuid: product.item_id
  };
}
var configPurchaseService = function configPurchaseService(_ref) {
  var _points_config$exclud;
  var basket_discount = _ref.basket_discount,
    brnumber = _ref.brnumber,
    driver_tip = _ref.driver_tip,
    extpromo_cloud_usage = _ref.extpromo_cloud_usage,
    fee_buster_config = _ref.fee_buster_config,
    first_order_discount = _ref.first_order_discount,
    modifierGroups = _ref.modifierGroups,
    overrides = _ref.overrides,
    points_config = _ref.points_config,
    price_increase = _ref.price_increase,
    products = _ref.products,
    promotions = _ref.promotions,
    service_fee = _ref.service_fee,
    store_tip = _ref.store_tip,
    tax_free_sale = _ref.tax_free_sale;
  extpromo_cloud_usage = extpromo_cloud_usage || [];

  // Handle fee buster config
  if (fee_buster_config) {
    purchaseService.feeBusterConfig = fee_buster_config;
  }

  // Handle points config
  if (points_config !== null && points_config !== void 0 && points_config.enabled && points_config !== null && points_config !== void 0 && (_points_config$exclud = points_config.excludedDepts) !== null && _points_config$exclud !== void 0 && _points_config$exclud.length) {
    purchaseService.pointsExcludedDepts = points_config.excludedDepts;
  }

  // Handle price increase config
  purchaseService.priceIncrease = price_increase.enabled;
  if (brnumber) {
    purchaseService.reg.brnumber = brnumber;
  }

  // Prepare purchases
  purchaseService.purchases.length = 0;
  products.forEach(function (p, i) {
    purchaseService.addItem(_transformProduct(p, i));
  });

  // Init intPrice for each item .
  // Important!!! this must be called before any other instruction
  purchaseService.getIntPricelist();

  // reset priceTaxFeeAdjusters
  purchaseService.priceTaxFeeAdjusters = [];

  // Set constants priceTaxFeeAdjusters
  [taxService, feeService, manualdiscountService, priceoverrideService].concat(_toConsumableArray(tax_free_sale ? [taxfreesaleService] : [])).forEach(function (service) {
    return purchaseService.priceTaxFeeAdjusters.push(new service.priceTaxFeeAdjuster());
  });
  if (overrides !== null && overrides !== void 0 && overrides.length) {
    purchaseService = overridePrices(overrides, purchaseService);
  }

  // Handle feebuster config PTF
  if (price_increase.enabled) {
    purchaseService.priceTaxFeeAdjusters.push(new feebusterService.priceTaxFeeAdjuster({
      excludedDepts: price_increase.excludedDepts
    }));
  }

  // Handle driver tip
  if (driver_tip) {
    purchaseService.drivertip = driver_tip;
  }

  // Handle service fee
  if (service_fee) {
    purchaseService.servicefee = service_fee;
  }

  // Handle modifiers PTFs
  purchaseService.purchases.forEach(function (p) {
    _addModifiersPriceTaxFeeAdjusters(p, modifierGroups);
  });

  // Handle promotions
  var uniqueUpcs = _toConsumableArray(new Set(products.map(function (a) {
    return a.upc;
  })));
  promotions = promotions ? promotions.filter(function (promotion) {
    return promotion.upcs.some(function (upc) {
      return uniqueUpcs.includes(upc);
    });
  }).map(function (promotion) {
    return _objectSpread(_objectSpread({}, promotion), {}, {
      upcs: promotion.upcs.filter(function (upc) {
        return uniqueUpcs.includes(upc);
      })
    });
  }) : [];
  var promoService = usePromoService(purchaseService);
  promoService.initializePromos(promotions, [], extpromo_cloud_usage);
  promoService.addPromosPtfs();

  // Add loyalty PTFs
  purchaseService.purchases.forEach(function (p) {
    var _p$redemptionClub, _p$redemptionPoints;
    // Add loyalty (coffee) clubs PTFs
    if ((_p$redemptionClub = p.redemptionClub) !== null && _p$redemptionClub !== void 0 && _p$redemptionClub.id || p.isRedemption) {
      var _p$redemptionClub$nam, _p$redemptionClub2, _p$redemptionClub3, _p$redemptionClub4, _p$redemptionClub$tok, _p$redemptionClub5;
      purchaseService.priceTaxFeeAdjusters.push(new freeproductsService.priceTaxFeeAdjuster({
        type: 'upc',
        list: [p.upc],
        limit: p.qty,
        source: {
          club: (_p$redemptionClub$nam = (_p$redemptionClub2 = p.redemptionClub) === null || _p$redemptionClub2 === void 0 ? void 0 : _p$redemptionClub2.name) !== null && _p$redemptionClub$nam !== void 0 ? _p$redemptionClub$nam : null,
          name: 'coffeeclub',
          id: ((_p$redemptionClub3 = p.redemptionClub) === null || _p$redemptionClub3 === void 0 ? void 0 : _p$redemptionClub3.id) || p.clubId,
          brnumber: brnumber,
          mechanism: (_p$redemptionClub4 = p.redemptionClub) === null || _p$redemptionClub4 === void 0 ? void 0 : _p$redemptionClub4.mechanism,
          token: (_p$redemptionClub$tok = (_p$redemptionClub5 = p.redemptionClub) === null || _p$redemptionClub5 === void 0 ? void 0 : _p$redemptionClub5.token) !== null && _p$redemptionClub$tok !== void 0 ? _p$redemptionClub$tok : null
        }
      }));
    }
    if ((_p$redemptionPoints = p.redemptionPoints) !== null && _p$redemptionPoints !== void 0 && _p$redemptionPoints.id || p.redemptionPointsOfferId) {
      var _p$redemptionPoints2, _p$redemptionPoints3, _p$redemptionPoints$n, _p$redemptionPoints4, _p$redemptionPoints5, _p$redemptionPoints$t, _p$redemptionPoints6;
      // Add loyalty points PTFs
      purchaseService.priceTaxFeeAdjusters.push(new freeproductsService.priceTaxFeeAdjuster({
        type: 'upc',
        list: [p.upc],
        limit: p.qty,
        source: {
          name: 'points',
          id: ((_p$redemptionPoints2 = p.redemptionPoints) === null || _p$redemptionPoints2 === void 0 ? void 0 : _p$redemptionPoints2.id) || p.redemptionPointsOfferId,
          brnumber: brnumber,
          mechanism: (_p$redemptionPoints3 = p.redemptionPoints) === null || _p$redemptionPoints3 === void 0 ? void 0 : _p$redemptionPoints3.mechanism,
          offer: (_p$redemptionPoints$n = (_p$redemptionPoints4 = p.redemptionPoints) === null || _p$redemptionPoints4 === void 0 ? void 0 : _p$redemptionPoints4.name) !== null && _p$redemptionPoints$n !== void 0 ? _p$redemptionPoints$n : null,
          pointsCost: ((_p$redemptionPoints5 = p.redemptionPoints) === null || _p$redemptionPoints5 === void 0 ? void 0 : _p$redemptionPoints5.cost) || p.redemptionPointsOffer,
          token: (_p$redemptionPoints$t = (_p$redemptionPoints6 = p.redemptionPoints) === null || _p$redemptionPoints6 === void 0 ? void 0 : _p$redemptionPoints6.token) !== null && _p$redemptionPoints$t !== void 0 ? _p$redemptionPoints$t : null
        }
      }));
    }
  });

  // Populate the PTFs
  purchaseService = calculatePriceTaxFeeAdjusters(purchaseService);

  // Populate the promo net impact object
  // Must follow _calculatePriceTaxFeeAdjusters()
  purchaseService.refreshIntPromoPricelist({
    field: 'intPromoPriceTotals',
    purchaselist: purchaseService.purchases
  });
  fee_buster_config.enabled && purchaseService.refreshIntPromoPricelist({
    field: 'intPromoPriceTotalsCash',
    purchaselist: purchaseService.getCashPricePurchases()
  });

  // Handle store tip
  if (store_tip) {
    var subtotal = purchaseService.totals.subtotal();
    if (store_tip.tipstype === 'amt') {
      purchaseService.tipsInformations = _objectSpread(_objectSpread({}, store_tip), {}, {
        tips: Math.round(store_tip.tipsamt / subtotal * 100)
      });
    } else {
      purchaseService.tipsInformations = _objectSpread(_objectSpread({}, store_tip), {}, {
        tipsamt: Math.round(subtotal * store_tip.tips / 100)
      });
    }
  }

  // Handle basket discount PTF
  if (basket_discount) {
    purchaseService.priceTaxFeeAdjusters = purchaseService.priceTaxFeeAdjusters.filter(function (a) {
      return a.name !== 'discountontotal';
    });
    purchaseService.priceTaxFeeAdjusters.push(new discountontotalService.priceTaxFeeAdjuster({
      discountType: basket_discount.discounttype,
      // "percentage" or "amt"
      discountAmount: basket_discount.discountamount,
      // number or undefined
      discountPercentage: basket_discount.discount,
      // number or undefined
      subtotal: purchaseService.totals.subtotal()
      // no need for useLowerItemPrices() here
    }));
  }

  // Handle first order discount PTF
  if (first_order_discount) {
    purchaseService.priceTaxFeeAdjusters = purchaseService.priceTaxFeeAdjusters.filter(function (a) {
      return a.name !== 'discountontotal';
    });
    var _subtotal = purchaseService.totals.subtotal();
    purchaseService.priceTaxFeeAdjusters.push(new discountontotalService.priceTaxFeeAdjuster({
      discountType: 'amt',
      discountAmount: Math.min(_subtotal, first_order_discount),
      discountPercentage: null,
      subtotal: _subtotal
      // no need for useLowerItemPrices() here
    }));
  }

  // Populate the PTFs
  return calculatePriceTaxFeeAdjusters(purchaseService);
};
module.exports = configPurchaseService;